export default __webpack_public_path__ + "static/media/VideoReview.1593a14f4d54c5e4f299b47f625d25fa.webp";